export default __webpack_public_path__ + "static/media/Short Line Rail.6deb29ef.svg";